import {
  IconCardMetaData,
  WidgetDefinition,
} from '../../../shared/types/widget';

export interface IconCardProps {
  definition: WidgetDefinition;
  content: IconCardMetaData;
}

function IconCard({ definition, content }: IconCardProps) {
  return (
    <>
      <div className="overflow-auto py-6">
        <div className="flex gap-x-6">
          <img
            src={`${import.meta.env.VITE_IMAGE_BASE_URL}${content?.data?.icon}`}
            className="h-24 w-24"
            alt={content?.data?.icon}
          />
          <div className="text-black-900">
            <h5 className="mb-4 text-4xl font-medium">
              {content?.data?.title}
            </h5>
            <p className="text-sm font-medium">{content?.data?.description}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default IconCard;
